import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";

/**
 * @param {{
 *   show: boolean,
 *   options?: {
 *     title: string,
 *     text: string
 *   }[],
 * onHide:()=>void,
 * submitClick:()=>{id:BigInteger,val:string},
 * id: BigInteger,
 * currentValue:string
 * }} props
 * */

function ModalEditTextArea({ show, onHide, id = null, submitClick = () => {}, currentValue = "", options = {} }) {
  const title = options.title ?? "Edit Text";
  const text = options.text ?? "Please edit this text. Default: -";

  const [val, setVal] = useState("");

  useEffect(() => {
    if (show) {
      setVal(currentValue || "");
    } else {
      setVal("");
    }
  }, [show, currentValue]);

  const handleSubmit = () => {
    if (!val) return;
    submitClick({ id, val });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeader closeButton>
        <h5 className="modal-title">{title}</h5>
      </ModalHeader>

      <ModalBody>
        <div className="mb-3">
          <textarea value={val} onChange={(e) => setVal(e.target.value)} className="form-control" />
        </div>

        <div className="alert bg-inverse bg-opacity-15">{text}</div>
      </ModalBody>

      <ModalFooter>
        <button type="button" disabled={!val} onClick={handleSubmit} className="btn btn-outline-theme">
          Save changes
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalEditTextArea;
